export enum BorderStyleOptions {
  NONE,
  ALL_SIDES,
  BOTTOM,
}
